import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const FORCE_LIGHT_ROUTES = [
  "/login",
  "/signup",
  "/dashboard"
];

const MARKETING_ROUTES = [
  "/",
  "/pricing",
  "/help",
  "/contact"
];

export default function useRouteTheme() {
  const location = useLocation();

  useEffect(() => {
    const root = document.documentElement;
    const path = location.pathname;

    const forceLight = FORCE_LIGHT_ROUTES.some(p =>
      path.startsWith(p)
    );

    const isMarketing = MARKETING_ROUTES.includes(path);

    if (forceLight) {
      root.classList.remove("dark");
      return;
    }

    // Default marketing pages = LIGHT
    if (isMarketing) {
      root.classList.remove("dark");
    }
  }, [location.pathname]);
}
